import { Grid } from '@mui/material'
import React, { createContext, useState } from 'react'
import AddEditForm from './AddEditForm'
import { PermissionGuard } from '../../../../components/PermissionGuard'
import { UrbanTypeServices } from '../UrbanType/UrbanTypeServices'
import { SlabServices } from './SlabServices'
import { CrudServices } from '../../../MasterService/CrudServices'
import SlabList from './SlabList'

const SlabDataContext = createContext();

const SubscriptionSlab = () => {
    const slabInitialData = {
        categoryId: '',
        SubscriptionUrbanTypeId: '',
        orderStart: 0,
        orderEnd: 0,
        subscriptionFee:0,
        subscriptionFeeWithGst:0,
        status:false,
    }
    const [slabData, setSlabData] = useState(slabInitialData);

    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
        filters: {
            searchKey: "",
            sortBy:'updatedAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [slabList, setSlabList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchSlabList = async() => {
        setLoadingList(true);
        try{
            const response = await SlabServices.fetchSlabList(paginationModel);
            console.log('slab list fetching response :',response);

            if(response.success == '1'){
                setSlabList(response.data.list)
                setTotalRowCount(response.data.totalItems)
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }finally{
            setLoadingList(false)
        }
        
        
    }
    const [urbanTypeList, setUrbanTypeList] = useState([]);
    const fetchUrbanTypeList = async() => {
            setLoadingList(true);
            try{
                const response = await UrbanTypeServices.fetchUrbanTypeList(paginationModel);
                console.log('urban type list fetching response :',response);
    
                if(response.success == '1'){
                    setUrbanTypeList(response.data.list)
                    setTotalRowCount(response.data.totalItems)
                }else if (response.success == '0'){
                    console.log("error :",response?.message)
                }
            }catch (error){
                console.log("error:",error)
            }finally{
                setLoadingList(false)
            }
            
        }

    const [selectedSlabData, setSelectedSlabData] = useState(null);
    const [loadingCategoryList, setLoadingCategoryList] = useState(false);
    const [categoryList, setCategoryList] = useState([]);

    const fetchCategoryList= async()=>{
        try {
            const categoryListResponse = await CrudServices.categoryList();
            console.log("category list Response:",categoryListResponse);
            if(categoryListResponse.success===1){
                setCategoryList(categoryListResponse.data)
            }
        } catch (error) {
        
        }
    }
  return (
    <SlabDataContext.Provider value={{slabInitialData,slabData,setSlabData,fetchSlabList,slabList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedSlabData, setSelectedSlabData,urbanTypeList,fetchUrbanTypeList,categoryList, setCategoryList,loadingCategoryList, setLoadingCategoryList,fetchCategoryList}}>
        <Grid container spacing={1}>            
            <Grid item xs={12} lg={3}>
                <AddEditForm/>
            </Grid>
            {/* <PermissionGuard feature="gst" permission="canView"> */}
                <Grid item xs={12} lg={9}>
                    <SlabList/>
                </Grid>
            {/* </PermissionGuard> */}
        </Grid>
    </SlabDataContext.Provider>
  )
}

export default SubscriptionSlab
export {SlabDataContext};
